<template>
  <div>
    <div v-if="loading">
      <p>Loading...........</p>
    </div>
    <div v-if="!loading">
      <b-row style="margin-top: -23px;">
        <b-col md="8"> </b-col>
        <b-col md="4">
          <div>
            <b-modal
              title="Agreement"
              header-class="header-nipige-class"
              id="agreementEdit"
              size="md"
              ref="agreementEdit"
              centered
              hide-footer
            >
              <sagreementmodel
                :catalogData="catalogNames"
                :marketListStore="marketListStore"
                :catalogCategoryNames="catalogCategoryNames"
                :catalogCategoryOptionsProp="catalogCategoryOptions"
              >
                <template v-slot:footer-button="data">
                  <b-row class="mt-3">
                    <b-col md="4"> </b-col>
                    <b-col md="4">
                      <b-button
                        class="btn btn-primary-outline"
                        btn-special="primary"
                        @click="AgreeToNext(data.data)"
                        >Update</b-button
                      >
                    </b-col>
                    <b-col md="4"></b-col>
                  </b-row>
                </template>
              </sagreementmodel>
            </b-modal>
            <b-button
              @click="agreementButtonClick()"
              class="main-navigation-button w-1 edit_button"
              variant="white"
              btn-color="primary1"
              style="margin-left: auto; display: block;"
            >
              <v-avatar class="ml-n2 mt-n1" size="35">
                <img src="img/Edit.png" /> </v-avatar
            ></b-button>
          </div>
        </b-col>
        <!-- <h5 class="text-muted ml-n4">{{ categoryTypeData }}</h5> -->
      </b-row>
      <b-row>
        <div>
          <h4 style="margin-top: -4px;">
            Catalog :
            <span
              v-for="items in catalogNames"
              :key="items._id"
              class=" text-muted"
              style="margin-left: 25px; font-size: 14px"
              >{{ items.name }}</span
            >
          </h4>
        </div>

        <!-- <h4>Catalog :</h4>
            <ul style="">
              <li
                class="list-style"
                v-for="items in catalogNames"
                :key="items._id"
              >
                {{ items.name }}
              </li>
            </ul> -->
      </b-row>
    </div>
    <!-- //////// -->
  </div>
</template>
<script>
import sagreementmodel from "@/components/Partner/PartnerEdit/Agreement";
import { mapGetters } from "vuex";
import currentUserMix from "@/mixins/currentUser";
export default {
  props: ["agreeData", "catalogDomainData"],
  mixins: [currentUserMix],
  components: {
    sagreementmodel
  },
  data() {
    return {
      catalogNames: [],
      catalogCategoryNames: [],
      catalogCategoryOptions: [],
      sameObjCount: [],

      loading: false,

      marketListStore: []
    };
  },
  methods: {
    async agreementButtonClick() {
      let dataDomain = this.$currentUserData.catalogInfo;
      if (
        Array.isArray(dataDomain) &&
        dataDomain.length > 0 &&
        dataDomain[0].categoryType != "CATEGORY"
      ) {
        try {
          if (
            Array.isArray(this.catalogNames) &&
            this.catalogNames.length > 0
          ) {
            this.catalogNames.forEach(async obj => {
              if (obj.isCategory) {
                if (!this.sameObjCount.includes(obj.parent)) {
                  this.sameObjCount.push(obj.parent);
                  await this.$store
                    .dispatch("catalog/fetchCatalogById", obj.parent)
                    .then(res => {
                      this.catalogCategoryNames.push(
                        this.$store.getters["catalog/GetCurrentReadCatalog"]
                          .response
                      );
                    });
                  let searchString = `parent=${obj.parent}`;
                  await this.$store.dispatch(
                    "catalog/fetchCatalogList",
                    searchString
                  );
                  this.catalogCategoryOptions.push(
                    ...this.$store.getters["catalog/GetCategoryList"].data
                      .response
                  );
                }
              } else {
              }
            });
          }
        } catch {}

        try {
          if (
            this.$store.getters["partner/GetPartnerData"].agreement
              .marketSegment[0].categoryType == "MARKET"
          ) {
            if (
              Array.isArray(this.catalogNames) &&
              this.catalogNames.length > 0
            ) {
              this.catalogNames.forEach(async obj => {
                if (obj.isMarket) {
                  let searchStringMarket = `parent=${obj._id}`;
                  await this.$store.dispatch(
                    "catalog/fetchCatalogList",
                    searchStringMarket
                  );

                  this.catalogCategoryOptions.push(
                    ...this.$store.getters["catalog/GetCategoryList"].data
                      .response
                  );
                }
              });
            }
          }
        } catch {}
      }
      this.$refs["agreementEdit"].show();
    },
    async callCatalogTree() {
      try {
        let dataDomain = this.$currentUserData.catalogInfo;
        if (
          Array.isArray(dataDomain) &&
          dataDomain.length > 0 &&
          dataDomain[0].categoryType == "DOMAIN"
        ) {
          let searchString = `parent=${dataDomain[0].catalogId}`;
          await this.$store.dispatch("catalog/fetchCatalogList", searchString);
          let domainRes = this.$store.getters["catalog/GetCategoryList"];
          this.marketListStore = domainRes.data.response;
        }
        if (
          Array.isArray(dataDomain) &&
          dataDomain.length > 0 &&
          dataDomain[0].categoryType == "MARKET"
        ) {
          dataDomain.forEach(async obj => {
            await this.$store
              .dispatch("catalog/fetchCatalogById", obj.catalogId)
              .then(res => {
                this.marketListStore.push(res.response);
              });
          });
        }

        if (
          Array.isArray(dataDomain) &&
          dataDomain.length > 0 &&
          dataDomain[0].categoryType == "CATEGORY"
        ) {
          dataDomain.forEach(async obj => {
            await this.$store
              .dispatch("catalog/fetchCatalogById", obj.catalogId)
              .then(res => {
                this.catalogCategoryOptions.push(res.response);
              });
          });
        } else {
        }
      } catch {}
    },

    AgreeToNext(data) {
      // this.$emit("agreementData", data);
      let agreementData = [];
      try {
        if (
          Array.isArray(data.catalogCategory) &&
          data.catalogCategory.length > 0
        ) {
          if (data.fetchCatagoryKey) {
            data.catalogCategory.map(obj => {
              agreementData.push({
                categoryType: "CATEGORY",
                catalogId: obj._id
              });
            });
          } else {
            data.catalog.map(obj => {
              agreementData.push({
                categoryType: data.market.value,
                catalogId: obj._id
              });
            });
          }
        } else {
          data.catalog.map(obj => {
            agreementData.push({
              categoryType: data.market.value,
              catalogId: obj._id
            });
          });
        }
      } catch {
        this.$swal({
          title: "Error",
          text: "Please select market and catalog properly",
          type: "error"
        });
      }

      let agreementPayload = {
        doc: data.doc,
        valid: data.valid,
        marketSegment: agreementData
        //   UPIID: "",
        //   endDate: "Fri Apr 16 2021 16:50:16 GMT+0530 (India Standard Time)",
        //   file: "",
        //   market: data.market.value,
        //   startDate: "Fri Apr 16 2021 16:50:16 GMT+0530 (India Standard Time)"
      };

      let payload = {
        id: this.partnerAllData._id,
        data: {
          agreement: agreementPayload
        }
      };

      this.$store
        .dispatch("partner/updatePartner", payload)
        .then(result => {
          console.log("result : ", result);
          this.$swal({
            title: "Success",
            text: "Partner Edited successfully!",
            type: "success"
          });
          this.$root.$emit("bv::hide::modal", "agreementEdit", "#btnShow");
        })
        .catch(error => {
          console.log(error);
          this.$swal({
            title: "Error",
            text: "Could not Edited partner",
            type: "error"
          });
        });
    }
  },
  computed: {
    ...mapGetters({
      partnerAllData: "partner/GetPartnerData",
      catalogTree: "catalog/GetCatalogTree"
    }),
    categoryTypeData() {
      if (this.agreeData.marketSegment.length > 0) {
        return this.agreeData.marketSegment[0].categoryType;
      } else {
        return null;
      }
    }
  },

  async mounted() {
    this.loading = true;

    try {
      if (this.agreeData && this.agreeData.marketSegment) {
        if (
          Array.isArray(this.agreeData.marketSegment) &&
          this.agreeData.marketSegment.length > 0
        ) {
          let storingCatalog = [];
          this.agreeData.marketSegment.forEach(async el => {
            await this.$store
              .dispatch("catalog/fetchCatalogById", el.catalogId)
              .then(res => {
                storingCatalog.push(
                  this.$store.getters["catalog/GetCurrentReadCatalog"].response
                );
              });
          });
          this.catalogNames = storingCatalog;
        }
      }
      await this.callCatalogTree();
    } catch {}

    this.loading = false;
  },

  computed: {
    ...mapGetters({
      partnerAllData: "partner/GetPartnerData",
      catalogTree: "catalog/GetCatalogTree"
    }),
    categoryTypeData() {
      if (this.agreeData.marketSegment.length > 0) {
        return this.agreeData.marketSegment[0].categoryType;
      } else {
        return null;
      }
    }
  }
};
</script>
<style scoped>
.text-style {
  font-family: 'Lato';
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 18px;
  /* or 138% */

  letter-spacing: 0.15px;

  color: rgba(143, 143, 143, 0.87);
}
.list-style {
  list-style-type: none;
  display: inline;
}

[btn-color="primary"] {
  height: 41px;
  background-color: #727cf5;
  font-weight: 600;
  font-size: medium;
  letter-spacing: 2px;
  font-family: 'Lato';
  color: white;
  border: 0px;
  border-radius: 0px;
}

[btn-special="primary"] {
  border: 0px;
  font-weight: 500;
  letter-spacing: 1px;
  font-size: medium;
  font-family: 'Lato';
  border-radius: 0px;
  height: 39px;
  width: 90px;
  background-color: #727cf5;
  color: white;
}
@media (max-width: 767px) {
  .my-content {
    display: none;
  }
}
@media (min-width: 767px) {
  .mobile-responsive {
    display: none;
  }
}
@media (max-width: 767px) {
  .edit_button {
    margin-top: -34px;
  }
}
</style>
